
import React from 'react';
import { useNavigate } from 'react-router-dom';
// import { AppUserContext } from '../../App';
import Nav from '../../components/breadcrumb';
import PaymentForm from './salaryform';
import moment from 'moment';
// import { ErrorLoading } from '../../components/loading';

const payment = {
    payroll_type: "",
    overtime_rate: 0,
    workers: []
}

const NewPayment = () => {

    const nav_items = [
        { title: "Payroll", href: "/app/payroll" },
        { title: 'Salaries', href: '/app/payroll/salaries' },
        { title: 'Initiate Payment' }
    ];

    const navigate = useNavigate();

    const handleSubmit = (details) => {
        navigate(`/app/payroll/salaries/${details.id}`);
    }

    // const { profile } = useContext(AppUserContext);

    // if (profile.roles.indexOf('finance') === -1) {
    //     return <ErrorLoading>You do not have permission to create an expense.</ErrorLoading>;
    // }



    return (
        <>
            <Nav items={nav_items} />

            <PaymentForm
                details={payment}
                action="create"
                onSubmit={handleSubmit}
            />
        </>
    )
}

/**
 * 
 * @param {Object} props
 * @param {import("../../resources/api/payroll").StaffPaymentObject} props.details 
 * @param {React.Dispatch<React.SetStateAction<import("../../resources/api/payroll").StaffPaymentObject>>} props.setDetails 
 */
const EditPayment = ({ details, setDetails }) => {

    const nav_items = [
        { title: 'Payroll', href: '/app/payroll' },
        { title: 'Salaries', href: '/app/payroll/salaries' },
        { title: moment(details.period_date).format("MMM YYYY"), href: `/app/payroll/salaries/${details.id}` },
        { title: 'Edit Details' }
    ];

    const navigate = useNavigate();

    const handleSubmit = (details) => {
        setDetails(d => ({ ...d, ...details }));
        navigate(`/app/payroll/salaries/${details.id}`);
    }


    return (
        <>
            <Nav items={nav_items} />

            <div className="max-800 p-2">
                <PaymentForm
                    details={details}
                    onSubmit={handleSubmit}
                    action="edit"
                />
            </div>
        </>
    )

}


export { EditPayment }

export default NewPayment;

